import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, CancelTransactionDialogueHandler } from '../types';
import CancelTransactionDialogueContext from './CancelTransactionContext';

const { ConfirmationDialogue } = vp;

type CancelTransactionDialogueProps = {
  handleDialogue: DialogueHandler<CancelTransactionDialogueHandler>;
};

type FC = FunctionComponent<CancelTransactionDialogueProps>;

const VoidTransactionDialogue: FC = ({ handleDialogue }: CancelTransactionDialogueProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Dialogue.CancelTransaction.CancelTransactionDialogue',
  });
  const { showCancelTransactionConfirmAlert, showCancelTransactionErrorAlert, sendCancelTransactionError } = useContext(
    CancelTransactionDialogueContext,
  );

  return useMemo(
    () => (
      <div>
        {/* Transaction Cancel Confirmation */}
        <ConfirmationDialogue
          isVisible={showCancelTransactionConfirmAlert}
          title={t('confirmDialogue.title')}
          status="alert"
          subTitle=""
          confirm={{
            label: t('confirmDialogue.yes'),
            action: () => handleDialogue({ type: 'alert', state: 'success' }),
          }}
          cancel={{
            label: t('confirmDialogue.no'),
            action: () => handleDialogue({ type: 'alert', state: 'fail' }),
          }}
        />
        {/* Transaction Cancel Error */}
        <ConfirmationDialogue
          isVisible={showCancelTransactionErrorAlert}
          title={t('errorDialogue.title')}
          status="error"
          subTitle={`${sendCancelTransactionError}`}
          confirm={{
            label: t('errorDialogue.back'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showCancelTransactionConfirmAlert, showCancelTransactionErrorAlert, sendCancelTransactionError],
  );
};

export default VoidTransactionDialogue;
